import { render, staticRenderFns } from "./FeedTanksTab.vue?vue&type=template&id=69ae0830&"
import script from "./FeedTanksTab.vue?vue&type=script&lang=ts&"
export * from "./FeedTanksTab.vue?vue&type=script&lang=ts&"
import style0 from "./FeedTanksTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports